import Card from "../../../components/Card";
import { Html5Qrcode } from "html5-qrcode";
import styles from "./Read.module.sass";
import { useEffect, useState } from "react";
import Empthy from "../../../components/Empty";
import Dropdown from "../../../components/Dropdown";
import Disclaimer from "../../../components/Disclaimer";
import Loader from "../../../components/Loader";
import { UseApi } from "../../../hooks/use-api";
import {
	SecretExperience,
	SecretExperienceCode,
} from "../../../Services/lib/admin";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import ExperienceComponent from "../Modal/experience";
import { useUser } from "../../../context";
import redeem from "../../../i11/Redeem";
import cn from "classnames";
import TextInput from "../../../components/TextInput";

const Reader = () => {
	const { locale } = useUser();
	const [camera, setCamera] = useState([]);
	const [expection, setExpection] = useState("");

	useEffect(() => {
		Html5Qrcode.getCameras()
			.then((devices) => {
				if (devices && devices.length) setCamera(devices);
			})
			.catch((err) => {
				console.log(err);
				setExpection(err.message);
				setCamera(null);
			});
	}, []);

	return (
		<Card title={redeem[locale].redeem_exp} classTitle="title-green">
			<Camera cameras={camera} expection={expection} />
		</Card>
	);
};

const Camera = ({ cameras, expection }) => {
	const { locale } = useUser();
	const [link, setLink] = useState(null);
	const [{ isLoading: isLoadingCode }, postLinkCode] = UseApi({
		service: SecretExperienceCode,
	});

	const [data, setData] = useState(null);

	const [{ isLoading }, postLink] = UseApi({
		service: SecretExperience,
	});

	const postLink_ = async (body) => {
		try {
			let res;
			if (body.qr) res = await postLink(body);
			else res = await postLinkCode(body);
			if (res && res.statusCode !== 404) {
				setData(res);
				ToastEmitter({
					type: "success",
					msg: "Succcessfully redeemed.",
				});
			} else {
				setLink(null);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		if (link) {
			postLink_(link);
		}
	}, [link]);

	if (!cameras)
		return (
			<div className={styles.container}>
				{link ? (
					<div>
						<Disclaimer>
							Successfully encoded QR code. Now we are processing it. Please
							wait patiently.
						</Disclaimer>
						{isLoading || isLoadingCode ? (
							<div className={styles.loader}>
								<Loader />
							</div>
						) : null}
					</div>
				) : (
					<>
						<Empthy
							title={
								typeof expection === "string" ? expection : "Permission denied"
							}
						/>
						<ManualInput setLink={setLink} isLoadingCode={isLoadingCode} />
					</>
				)}
			</div>
		);
	if (cameras.length === 0)
		return (
			<div className={styles.container}>
				{link ? (
					<div>
						<Disclaimer>
							Successfully encoded QR code. Now we are processing it. Please
							wait patiently.
						</Disclaimer>
						{isLoading || isLoadingCode ? (
							<div className={styles.loader}>
								<Loader />
							</div>
						) : null}
					</div>
				) : (
					<>
						<Empthy title={redeem[locale].no_cam} />
						<ManualInput setLink={setLink} isLoadingCode={isLoadingCode} />
					</>
				)}
			</div>
		);
	if (cameras.length > 0)
		return (
			<ReaderLocal
				link={link}
				setLink={setLink}
				cameras={cameras}
				isLoadingCode={isLoadingCode}
				data={data}
				isLoading={isLoading}
			/>
		);
};

const ReaderLocal = ({
	cameras,
	link,
	setLink,
	isLoadingCode,
	data,
	isLoading,
}) => {
	const [html5QrCode, setHtml5QrCode] = useState(null);

	useEffect(() => {
		setHtml5QrCode(new Html5Qrcode("reader"));
	}, []);

	if (data)
		return (
			<div className={styles.container}>
				<ExperienceComponent data={data} readOnly />
			</div>
		);

	return (
		<div className={styles.container}>
			<div id="reader" className={styles.reader} />
			{link ? (
				<div>
					<Disclaimer>
						Successfully encoded QR code. Now we are processing it. Please wait
						patiently.
					</Disclaimer>
					{isLoading || isLoadingCode ? (
						<div className={styles.loader}>
							<Loader />
						</div>
					) : null}
				</div>
			) : null}
			{html5QrCode && !link ? (
				<Cam
					html5QrCode={html5QrCode}
					cameras={cameras}
					isLoadingCode={isLoadingCode}
					setLink={setLink}
				/>
			) : null}
		</div>
	);
};

const Cam = ({ html5QrCode, cameras, setLink, isLoadingCode }) => {
	const [active, setActive] = useState(cameras[0].id);

	useEffect(() => {
		if (active && html5QrCode) {
			html5QrCode
				.start(
					active,
					{
						fps: 10,
						qrbox: { width: 200, height: 200 },
					},
					(decodedText) => {
						const decoded = decodedText.split("code=")[1].split("&qr=");
						const link = {
							code: decoded[0],
							qr: decoded[1],
						};
						console.log("link ===>", link);
						setLink(link);
					}
				)
				.catch((err) => {
					console.log(err);
				});
		}
	}, [active, html5QrCode]);

	useEffect(() => {
		return () => {
			html5QrCode.stop();
		};
	}, []);
	return (
		<>
			<Dropdown
				value={active}
				setValue={(cam) => {
					html5QrCode.stop();
					setActive(cam);
				}}
				options={cameras.map((e) => e.id)}
				dictionary={cameras.reduce((p, c) => {
					p[c.id] = { title: c.label.split(" (")[0] };
					return p;
				}, {})}
			/>
			<ManualInput setLink={setLink} isLoadingCode={isLoadingCode} />
		</>
	);
};

const ManualInput = ({ setLink, isLoadingCode }) => {
	const [code, setCode] = useState("");

	const Submit = () => {
		setLink({
			code,
		});
	};
	return (
		<>
			<p className={styles.para}>Or</p>
			<TextInput
				value={code}
				onChangeInput={setCode}
				placeholder="Insert redeem code"
			/>
			<button
				onClick={Submit}
				className={cn("button", styles.button, {
					[styles.disabled]: isLoadingCode,
				})}
			>
				{isLoadingCode && <Loader />}
				Submit
			</button>
		</>
	);
};

export default Reader;
